const domain = process.env.VUE_APP_ROOT_API;
export const apiUrls = {
    IMAGEN: `${domain}imagen`,
    SETTING: `${domain}setting`,
    MESSAGE: `${domain}message`,
    LINK: `${domain}link`,
    USER: `${domain}user`,
    NOTICE: `${domain}notice`
}